import { render, staticRenderFns } from "./OrganizationPreview.vue?vue&type=template&id=89089320&"
import script from "./OrganizationPreview.vue?vue&type=script&lang=js&"
export * from "./OrganizationPreview.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPreview.vue?vue&type=style&index=0&id=89089320&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports